import React from 'react';
import lazyGettext from 'js-utils/lazy-gettext';
import { ACCOUNT_SETTINGS_URL } from '../../constants/main';

import LockSvg from 'eventbrite_design_system/iconography/icons/Lock';

export default {
    breadcrumbs: {
        crumbs: [
            {
                path: ACCOUNT_SETTINGS_URL,
                label: lazyGettext('Account Settings'),
            },
            {
                path: '#',
                label: lazyGettext('Change Package'),
            },
        ],
    },
    iconHero: {
        heading: lazyGettext(
            'You do not have permissions to change your account package. Contact your account owner to change your package.',
        ),
        iconType: <LockSvg />,
        dataAutomation: 'change-plan-access-text',
    },
};
